import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";
import { Payload } from "../../../types/api/api.types";

const { post, get } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "member/enrollment";

// eslint-disable-next-line arrow-parens
export const saveSIUnderwriting = async (payload: any) => {
	try {
		const endpoint = `${initialRoute}/VEB/si-underwriting`;
		const token = localStorage.getItem("@jwt_member");
		const response = await post(endpoint, payload, {
			...headers,
			Authorization: `Bearer ${token}`
		});

		if (response) {
			const { data } = response;
			const message = data?.message ?? "";

			// ← backend returns "Saved successfully" not "Data added successfully"
			const isSuccess =
				message === MESSAGE.post.succ || // "Data added successfully"
				message === "Saved successfully"; // what backend actually returns

			if (isSuccess) {
				return data?.result ?? data;
			}
		}
		throw new Error("RESPONSE_FAILED");
	} catch (error: any) {
		if (!error?.response) {
			console.error("No response object:", error?.message);
			throw error;
		}

		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;
			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;
			alert(message);
		} else {
			throw error;
		}
	}
};

export const getSIUnderwritingByEnrollment = async (member_SSN: string, open_enrollment_id: string) => {
	try {
		const endpoint = `${initialRoute}/VEB/get-si-underwriting?member_SSN=${member_SSN}&open_enrollment_id=${open_enrollment_id}`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;
			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;
			alert(message);
		} else {
			throw error;
		}
	}
};
